var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "auth-template",
    [
      _c(
        "va-card",
        { staticClass: "pa-6" },
        [
          _c("div", { staticClass: "va-title mb-2" }, [
            _vm._v(_vm._s(_vm.$t("resetPassword.title")))
          ]),
          _vm._v(" " + _vm._s(_vm.$t("resetPassword.content")) + " "),
          _c("va-notification", { attrs: { type: "info" } }, [
            _vm._v(_vm._s(_vm.$t("resetPassword.criteria")) + " ")
          ]),
          _c(
            "v-form",
            {
              ref: "resetForm",
              attrs: { "lazy-validation": "", onSubmit: "return false;" },
              on: { submit: _vm.onSubmit },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c("va-text-field", {
                staticClass: "mt-6",
                attrs: {
                  rules: [
                    _vm.required,
                    _vm.strongPassword,
                    _vm.maxLength(_vm.password, 64)
                  ],
                  label: _vm.$t("signUp.password"),
                  password: ""
                },
                model: {
                  value: _vm.password,
                  callback: function($$v) {
                    _vm.password = $$v
                  },
                  expression: "password"
                }
              }),
              _c("va-text-field", {
                staticClass: "mt-6",
                attrs: {
                  rules: [_vm.required, _vm.matching],
                  label: _vm.$t("signUp.repeatPassword"),
                  password: ""
                },
                model: {
                  value: _vm.confirmPassword,
                  callback: function($$v) {
                    _vm.confirmPassword = $$v
                  },
                  expression: "confirmPassword"
                }
              }),
              _c(
                "div",
                { staticClass: "text-right mb-3 mt-1" },
                [
                  _c("router-link", { attrs: { to: "/auth/signin" } }, [
                    _vm._v(" " + _vm._s(_vm.$t("signUp.back")) + " ")
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "d-flex mt-5" },
                [
                  _c("va-button", {
                    staticClass: "flex-grow-1",
                    attrs: {
                      submit: "",
                      disabled: !_vm.valid,
                      loading: _vm.$store.getters["session/isLoading"],
                      cta: _vm.$t("common.submit")
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }